(function() {
    'use strict';

    angular
        .module('surveyCampaignControllers')
        .controller('SelectNewRespondentController', Controller);

    Controller.$inject = ['$scope', 'esbEmployeeService', 'pagerService'];

    function Controller($scope, searchService, pagerService) {
        $scope.ctxSelectNewRespondent = {};

        $scope.availableRespondents = [];
        $scope.pager = pagerService.newPager({ numberOfItemsPerPage: 11 });

        $scope.pager.updatePagerFromItems($scope.availableRespondents);

        $scope.searchEmployees = function() {
            var searchTerm = $scope.ctxSelectNewRespondent.searchTerm;
            if (_.isUndefined(searchTerm) || searchTerm.length < 3) {
                $scope.availableRespondents = [];
                $scope.pager.updatePagerFromItems($scope.availableRespondents);
                return;
            }
            searchService
                .searchEmployeesForSendEmail(searchTerm)
                .then(function(foundEmployees) {
                    $scope.availableRespondents = _.filter(foundEmployees, function(foundEmployee) {
                        return !foundEmployee.DepartureDate &&
                            _.findIndex($scope.actualRespondents, { PSPEmployeeID: foundEmployee.PSPEmployeeID }) === -1;
                    });
                    $scope.pager.updatePagerFromItems($scope.availableRespondents);
                });
        }
    }
})();